export const radii = { none: 0, sm: 4, md: 8, lg: 10, card: 8, pill: 999 } as const;

export type RadiusToken = keyof typeof radii;

export const r = (token: RadiusToken): string => `${radii[token]}px`;
